export const company = {
  statusId: 1,
  companyId: 10087,
  codigoUsuarioMaestro: null,
};

export const companyForm = {
  id: 10087,
};

export const paginationTopLimit = {
  limit: 9,
  topLimit: 999999999,
  limitPage: 1,
};
